import(/* webpackMode: "eager" */ "/workspace/apps/home-webapp/src/app/(home)/@section5/page.tsx");
